import APIService from '@/services/APIService.js'

export default {
  getImportacaoDetalhes(id) {
    return APIService.apiCall().get('importacoes/getImportacaoDetalhes/'+id)
  },
  getTipoImportacao () {
    return APIService.apiCall().get('importacoes/getTipoImportacao')
  },
  getTabelasAfetadas (preImpoId){
    return APIService.apiCall().get('importacoes/getTabelasAfetadas/'+preImpoId)
  },
  addImportacao(preImpoId,acoes){
    return APIService.apiCall().post('importacoes/addImportacao/'+preImpoId, JSON.stringify(acoes))
  },
  getImportacoes () {
    return APIService.apiCall().get('importacoes/getImportacoes')
  },
  getImportacoesDados () {
    return APIService.apiCall().get('importacoes/getImportacoesDados')
  },
  getDadosPreview (postData) {
    return APIService.apiCall().post('importacoes/preview', JSON.stringify(postData))
  },
  getTipoImportacaoHexa () {
    return APIService.apiCall().get('importacoes/getTipoImportacaoHexa')
  },
  salvarPreImportacao (postData) {
    return APIService.apiCall().post('preImportacoesDados/processar', JSON.stringify(postData))
  },
  salvarPreImportacaoAdm (postData) {
    return APIService.apiCall().post('preImportacoesDados/processar', JSON.stringify(postData))
  },
  downloadLog(id,config={}) {
    return APIService.apiCall().get(`/importacoes/baixarLog/${id}`, { responseType: "blob", ...config });
  }
}
